// prop-type is a library for typechecking of props
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { authSelector } from "redux/selector";

// @mui material components
import Grid from "@mui/material/Grid";

// components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// NewUser page components
import { useLocation, useParams } from "react-router-dom";
import FormField from "components/FormField";
import SoftEditor from "components/SoftEditor";
import SelectField from "components/SelectField";
import FileField from "components/FileUploadField";
import { STATUS_INVOICE_ENUM } from "enums/status-invoice-type";
import { useState } from "react";
const statusOption = [
  { value: true, label: STATUS_INVOICE_ENUM.ACTIVE },
  {
    value: false,
    label: STATUS_INVOICE_ENUM.EXPIRED,
  },
];

function CompanyInfo({ formData, data }) {
  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const [isActive, setIsActive] = useState();
  const { formField, values, errors, touched, setFieldValue } = formData;
  const {
    numberOfRegistrations,
    invoiceSymbol,
    status,
    used,
    name,
    from,
    to,
    dayActive,
    invoiceSample,
    supplierName,
    supplierTaxCode,
  } = formField;
  const {
    numberOfRegistrations: numberOfRegistrationsV,
    invoiceSymbol: invoiceSymbolV,
    status: statusV,
    used: usedV,
    name: nameV,
    from: fromV,
    to: toV,
    dayActive: dayActiveV,
    invoiceSample: invoiceSampleV,
    supplierName: supplierNameV,
    supplierTaxCode: supplierTaxCodeV,
  } = values;
  const { user } = useSelector(authSelector);
  const [company, setCompany] = useState({});

  useEffect(() => {
    if (user && user.company._id) {
      setCompany(user.company);
    }
    if (data) {
      setFieldValue("invoiceSymbol", data?.invoiceSymbol);
      setFieldValue("numberOfRegistrations", data?.numberOfRegistrations);
      setFieldValue("used", data?.used | 0);
      setFieldValue("status", data?.isActive);
      setFieldValue("name", data?.name);
      setFieldValue("invoiceSample", data?.invoiceSample);
      setFieldValue("status", data?.isActive);
      setFieldValue("from", data?.from);
      setFieldValue("to", data?.to);
      setFieldValue("dayActive", data?.dayActive);
      setFieldValue("supplierName", data?.supplierName);
      setFieldValue("supplierTaxCode", data?.supplierTaxCode);
    }
  }, [id, data]);

  return (
    <SoftBox>
      <SoftBox lineHeight={0}>
        <SoftTypography variant="h5" fontWeight="bold">
          {id ? (containEdit ? "Cập nhật" : "Chi tiết") : "Tạo"} Cuốn hóa đơn
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type="text"
              label="Tên công ty"
              name="companyName"
              value={company.name || ""}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type="text"
              label="Mã số thuế"
              name="taxCode"
              disabled={true}
              value={company.taxCode || ""}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type="text"
              label="Địa chỉ công ty"
              name="address"
              disabled={true}
              value={company.address || ""}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type="text"
              label="Số điện thoại"
              name="phone"
              value={company.phone || ""}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={name.type}
              label={name.label}
              name={name.name}
              value={nameV}
              placeholder={name.placeholder}
              error={errors.name && touched.name}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={invoiceSymbol.type}
              label={invoiceSymbol.label}
              name={invoiceSymbol.name}
              value={invoiceSymbolV}
              placeholder={invoiceSymbol.placeholder}
              error={errors.invoiceSymbol && touched.invoiceSymbol}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={invoiceSample.type}
              label={invoiceSample.label}
              name={invoiceSample.name}
              value={invoiceSampleV}
              placeholder={invoiceSample.placeholder}
              error={errors.invoiceSample && touched.invoiceSample}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={numberOfRegistrations.type}
              label={numberOfRegistrations.label}
              name={numberOfRegistrations.name}
              value={numberOfRegistrationsV}
              placeholder={numberOfRegistrations.placeholder}
              error={errors.numberOfRegistrations && touched.numberOfRegistrations}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={from.type}
              label={from.label}
              name={from.name}
              value={fromV}
              placeholder={from.placeholder}
              error={errors.from && touched.from}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={to.type}
              label={to.label}
              name={to.name}
              value={toV}
              placeholder={to.placeholder}
              error={errors.to && touched.to}
            />
          </Grid>
          <Grid item xs={12} sm={12} style={{ paddingTop: "0px" }}>
            <FormField
              type={dayActive.type}
              label={dayActive.label}
              name={dayActive.name}
              value={dayActiveV}
              placeholder={dayActive.placeholder}
              error={errors.dayActive && touched.dayActive}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={supplierName.type}
              label={supplierName.label}
              name={supplierName.name}
              value={supplierNameV}
              placeholder={supplierName.placeholder}
              error={errors.supplierName && touched.supplierName}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={supplierTaxCode.type}
              label={supplierTaxCode.label}
              name={supplierTaxCode.name}
              value={supplierTaxCodeV}
              placeholder={supplierTaxCode.placeholder}
              error={errors.supplierTaxCode && touched.supplierTaxCode}
            />
          </Grid>
          {id ? (
            <>
              <Grid item xs={12} md={6} style={{ paddingTop: "0px" }}>
                <SelectField
                  options={statusOption}
                  label={status.label}
                  name={status.name}
                  value={statusV}
                  error={errors.status && touched.status}
                  success={status.length > 0 && !errors.status}
                />
              </Grid>
              <Grid item xs={12} md={6} style={{ paddingTop: "0px" }}>
                <FormField
                  type={used.type}
                  label={used.label}
                  name={used.name}
                  value={usedV}
                  placeholder={used.placeholder}
                  error={errors.used && touched.used}
                  readOnly={true}
                />
              </Grid>
            </>
          ) : (
            ""
          )}
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}

// typechecking props for CompanyInfo
CompanyInfo.propTypes = {
  data: PropTypes.any,
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default CompanyInfo;
